export default {
  en: {
    tabAll: 'All',
    tabNew: 'New',
    tabNotCompleted: 'Not completed',
    tabCompleted: 'Completed',
  },
  ru: {
    tabAll: 'Все',
    tabNew: 'Новое',
    tabNotCompleted: 'Не пройденное',
    tabCompleted: 'Пройденное',
  },
  de: {
    tabAll: 'Alle',
    tabNew: 'Neu',
    tabNotCompleted: 'Nicht abgeschlossen',
    tabCompleted: 'Abgeschlossen',
  },
  pt: {
    tabAll: 'Todos',
    tabNew: 'Novos',
    tabNotCompleted: 'Não concluídos',
    tabCompleted: 'Concluídos',
  },
  fr: {
    tabAll: 'Tous',
    tabNew: 'Nouveaux',
    tabNotCompleted: 'Non terminés',
    tabCompleted: 'Terminés',
  },
  es: {
    tabAll: 'Todos',
    tabNew: 'Nuevos',
    tabNotCompleted: 'No completados',
    tabCompleted: 'Completados',
  },
};
